import { useQuery } from "@tanstack/react-query";
import { EPromotionsAPI } from "../api";
import { LOCAL_STORAGE_USER } from "../utils/customConfig";

const fetchData = (sellerId) => {
  return EPromotionsAPI.get({ params: { sellerId } });
};

export const useFetchPromotions = (sellerId) => {
  return useQuery({
    queryKey: ["products"],
    queryFn: () => fetchData(sellerId),
    keepPreviousData: true, // smooth switching
  });
};
